/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_First_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "First Name" |
*
* @param {Team_Manager_First_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_first_name_placeholder = /** @type {((inputs?: Team_Manager_First_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_First_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prénom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome di battesimo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de pila")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファーストネーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहला नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Primeiro nome")
	return /** @type {LocalizedString} */ ("First Name")
});